<div class="header_search">
  <div class="title-page">
    <h3>Meta/Realizado</h3>
  </div>
  <div class="content_search m-r">
    <button type="button" class="btn-back" *ngIf="permission?.childIndicators" (click)="viewIndicadores.filho = !viewIndicadores?.filho">{{viewIndicadores?.filho ? 'Ocultar' : 'Mostrar'}} Indicadores Filhos</button>
    <button type="button" class="btn-back" *ngIf="permission?.refIndId" (click)="viewIndicadores.exeAnt = !viewIndicadores?.exeAnt">{{viewIndicadores?.exeAnt ? 'Ocultar' : 'Mostrar'}} Exercícios Anteriores</button>
    <button type="button" class="btn-back" *ngIf="permission?.summedIndicators" (click)="viewIndicadores.somados = !viewIndicadores?.somados">{{viewIndicadores?.somados ? 'Ocultar' : 'Mostrar'}} Indicadores Somados</button>
  </div>
</div>

<form [formGroup]="form" *ngIf="indicadoresList?.length">
  <ng-container *ngFor="let indicadores of indicadoresList; let ind = index">
    <div *ngIf="indicadores?.type_indicador == 4">
      <div class="info-page">
        <h3>{{ indicadores?.title }}</h3>
      </div>
      <div class="system-table table-container table-form system-table-m-b">
        <div class="system-table-conteiner system-table-form-conteiner">
          <table>
            <thead>
              <tr>
                <th class="title-scroll">#</th>
                <th class="text-center" *ngFor="let month of indicadores?.month">{{ month }}</th>
                <th class="text-center" *ngIf="indicadores?.accumShow">Total</th>
              </tr>
            </thead>
            <tbody formArrayName="row">
              <tr *ngIf="indicadores?.type_table">
                <td class="title title-scroll">{{indicadores?.label_numerator}}</td>
                <td *ngFor="let item of indicadores?.month; let i = index" [formGroupName]="i">
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <input type="text" class="form-control text-right" formControlName="numerator" (keyup)="formatarMedidaFisica(i, 'numerator', ind)">
                    </div>
                  </div>
                </td>
                <td class="text-center" *ngIf="indicadores?.accumShow">
                  {{indicadores?.total?.numerator}}
                </td>
              </tr>
              <tr *ngIf="indicadores?.type_table">
                <td class="title title-scroll gray">{{indicadores?.label_denominator}}</td>
                <td *ngFor="let item of indicadores?.month; let i = index" [formGroupName]="i">
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <input type="text" class="form-control text-right" formControlName="denominator" (keyup)="formatarMedidaFisica(i, 'denominator', ind)">
                    </div>
                  </div>
                </td>
                <td class="text-center" *ngIf="indicadores?.accumShow">
                  {{indicadores?.total?.denominator}}
                </td>
              </tr>
              <tr>
                <td class="title title-scroll">Meta</td>
                <td *ngFor="let item of indicadores?.month; let i = index" [formGroupName]="i">
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <input type="text" class="form-control text-right" formControlName="goal" (keyup)="formatarMedidaFisica(i, 'goal', ind)">
                    </div>
                  </div>
                </td>
                <td class="text-center" *ngIf="indicadores?.accumShow">
                  {{indicadores?.total?.goal}}
                </td>
              </tr>
              <tr>
                <td class="title title-scroll gray">Realizado</td>
                <td *ngFor="let item of indicadores?.month; let i = index" [formGroupName]="i">
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <input type="text" class="form-control text-right" formControlName="done" (keyup)="formatarMedidaFisica(i, 'done', ind)" [readOnly]="indicadores?.type_table">
                    </div>
                  </div>
                </td>
                <td class="text-center" *ngIf="indicadores?.accumShow">
                  {{indicadores?.total?.done}}
                </td>
              </tr>
              <tr>
                <td class="title title-scroll">Status</td>
                <td class="status" *ngFor="let item of indicadores?.month; let i = index">
                  <div *ngIf="indicadores?.list[i]?.sum_status1; else status0" [innerHTML]="indicadores?.list[i]?.sum_status1"></div>
                  <ng-template #status0>
                    <span class="ind-status ind-status-0"></span>
                  </ng-template>
                </td>
                <td class="text-center" *ngIf="indicadores?.accumShow"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div *ngIf="indicadores?.type_indicador == 5 || (indicadores?.type_indicador == 1 && viewIndicadores?.filho) || (indicadores?.type_indicador == 2 && viewIndicadores?.exeAnt) || (indicadores?.type_indicador == 3 && viewIndicadores?.somados)">
      <div class="info-page">
        <h3>{{ indicadores?.title }}</h3>
      </div>
      <div class="system-table table-container table-form system-table-m-b">
        <div class="system-table-conteiner system-table-form-conteiner">
          <table>
            <thead>
              <tr>
                <th class="title-scroll">#</th>
                <th class="text-center" *ngFor="let month of indicadores?.month">{{ month }}</th>
                <th class="text-center" *ngIf="indicadores?.accumShow">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="indicadores?.type_table">
                <td class="title title-scroll">{{indicadores?.label_numerator}}</td>
                <td class="text-center" *ngFor="let item of indicadores?.list">
                  {{item?.numerator}}
                </td>
                <td class="text-center" *ngIf="indicadores?.accumShow">
                  {{indicadores?.total?.numerator}}
                </td>
              </tr>
              <tr *ngIf="indicadores?.type_table">
                <td class="title title-scroll gray">{{indicadores?.label_denominator}}</td>
                <td class="text-center" *ngFor="let item of indicadores?.list">
                  {{item?.denominator}}
                </td>
                <td class="text-center" *ngIf="indicadores?.accumShow">
                  {{indicadores?.total?.denominator}}
                </td>
              </tr>
              <tr>
                <td class="title title-scroll">Meta</td>
                <td class="text-center" *ngFor="let item of indicadores?.list">
                  {{item?.goal}}
                </td>
                <td class="text-center" *ngIf="indicadores?.accumShow">
                  {{indicadores?.total?.goal}}
                </td>
              </tr>
              <tr>
                <td class="title title-scroll gray">Realizado</td>
                <td class="text-center" *ngFor="let item of indicadores?.list">
                  {{item?.done}}
                </td>
                <td class="text-center" *ngIf="indicadores?.accumShow">
                  {{indicadores?.total?.done}}
                </td>
              </tr>
              <tr>
                <td class="title title-scroll">Status</td>
                <td class="status" *ngFor="let item of indicadores?.month; let i = index">
                  <div *ngIf="indicadores?.list[i]?.sum_status1; else status0" [innerHTML]="indicadores?.list[i]?.sum_status1"></div>
                  <ng-template #status0>
                    <div><span class="ind-status ind-status-0"></span></div>
                  </ng-template>
                </td>
                <td *ngIf="indicadores?.accumShow"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-container>
</form>

<div class="grafico-meta" *ngIf="indicador?.viewInfoActive && indicador?.chartData">
  <canvas baseChart class="chart" [data]="indicador?.chartData" [options]="indicador?.chartOptions" [type]="indicador?.chartType"></canvas>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div>
      <div class="legenda">
        <p><strong>Legenda:</strong></p>
        <p>
          <span class="ind-status ind-status-0"></span><span class="lbl">Sem informação</span>
        </p>
        <p>
          <span class="ind-status ind-status-1"></span><span class="lbl">Igual ou superior a {{status?.status_ok}}</span>
        </p>
        <p>
          <span class="ind-status ind-status-2"></span><span class="lbl">Entre {{status?.status_warn}} e {{status?.status_ok}}</span>
        </p>
        <p>
          <span class="ind-status ind-status-3"></span><span class="lbl">Abaixo de {{status?.status_alert}}</span>
        </p>
      </div>
    </div>
  </div>
</div>

<div class="form-group row d-flex justify-content-end m-t">
  <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
    <button *ngIf="indicador?.can_edit_meta" class="btn btn-primary btn" type="button" (click)="salvar()">Salvar</button>
  </div>
</div>
<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>

<app-loading [loader]="isLoading"></app-loading>